

import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import area from '@/utils/area'
import AreaSelect from '@/components/area-select.vue'
import { apiAgentEdit, apiAgentListAll } from '@/api/agent/agent'

@Component({
  components: {
    AreaSelect
  }
})
export default class EditAgent extends Vue {
  $refs!: { form: any }
  
  /** S Prop*/
  @Prop() value!: boolean
  @Prop() data!: object
  
  /** E Prop*/
  
  /** S Computed*/
  get show (): boolean {
    return this.value
  }
  
  set show (val) {
    this.$emit('input', val)
  }
  
  /** E Computed*/
  
  /** S Data*/
  areaOptions: Array<object> = area
  yearDiscountOptions = [9, 8, 7, 6, 5]
  form: any = {
    name: '',
    mobile: '',
    contact: '',
    id: '',
    type: 0,
    province: '',
    city: '',
    district: '',
    year_discount: 9,
    commission_rate: 0,
    margin: 0,
    expect_money: 0,
    expires_time: ''
  }
  formRules = {
    name: [
      { required: true, message: '请输入代理商名称', trigger: 'blur' }
    ],
    mobile: [
      { required: true, message: '请输入手机号', trigger: 'blur' }
    ],
    contact: [
      { required: true, message: '请输入联系人姓名', trigger: 'blur' }
    ],
    city: [
      { required: true, message: '请选择所在地区', trigger: 'change' }
    ],
    expires_time: [
      { required: true, message: '请选择到期时间', trigger: 'change' }
    ],
  }
  
  /** E Data*/
  
  /** S Methods*/
  submit () {
    this.$refs.form.validate((valid: boolean) => {
      if (!valid) return
      this.$emit('submit', this.form)
    })
  }
  
  /** E Methods*/
  
  @Watch('data')
  dataChange (val: object) {
    this.form = val
  }
}
